import React, { useState, useEffect } from "react";
import {
  CardElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import './../stripe/stripe.scss'
import ReactLoading from 'react-loading';
export default function CheckoutForm(props) {
  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [clientSecret, setClientSecret] = useState('');
  const stripe = useStripe();
  const elements = useElements();


  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    //console.log(process.env.REACT_APP_API_URL)

    window
      .fetch(`${process.env.REACT_APP_API_URL}/create-payment-intent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          customer: props.data.customer,
          deliverytime: props.data.deliverytime,
          pointderetrait: props.data.pointderetrait,
          card: props.data.card,

        })
      })
      .then(res => {
        return res.json();
      })
      .then(data => {
        setClientSecret(data.clientSecret);
      }).catch(ex => props.errorCallBack(ex))
  }, []);

  const cardStyle = {
    style: {
      base: {
        color: "#32325d",
        fontFamily: 'Arial, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#32325d"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    }
  };

  const webhookState = async (pyid) => fetch(`${process.env.REACT_APP_API_URL}/py/${pyid}`)

  const handleChange = async (event) => {
    // Listen for changes in the CardElement
    // and display any errors as the customer types their card details
    setDisabled(event.empty);
    setError(event.error ? event.error.message : "");
  };

  const handleSubmit = async ev => {
    ev.preventDefault();
    setProcessing(true);

    const payload = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement)
      }
    });

    if (payload.error) {
      setError(`Payment failed ${payload.error.message}`);
      setProcessing(false);
    } else {
      setError(null);
      setProcessing(false);
      setSucceeded(true);

      try {
        let statusresponse = await webhookState(clientSecret.split('_secret_')[0])
        let status = await statusresponse.text()
        if (status === "OK") {
          props.Callback("OK")
        }
        if (status === "KO") {
          props.Callback("KO")

        }

      } catch (error) {
        console.log("statusErr to call")
      }
    }
  };

  return (
    <div>
      <form id="payment-form" onSubmit={handleSubmit}>
        <CardElement id="card-element" options={cardStyle} onChange={handleChange} />
        <button
          disabled={processing || disabled || succeeded}
          id="submit"
        >
          <span id="button-text">
            {processing ? (
              <div className="spinner" id="spinner"></div>
            ) : (
              "Payez maintenant"
            )}
          </span>
        </button>
        {error && (
          <div className="card-error" role="alert">
            {error}
          </div>
        )}
        <p className={succeeded ? "result-message" : "result-message hidden"}>
          Paiement valider, commande en cours de validation
        </p>
      </form>
      {succeeded &&
        <ReactLoading type="spinningBubbles" color="#a9b4e9" className="ReactLoading" height={65} width={65} />}
    </div>

  );
}
